import React from 'react';

import { Button } from 'components/core/Button';
import { Container } from 'components/core/Page';

import PropTypes from 'prop-types';
import './JumpNav.scss';
import { quickLinks } from '../../psp/PSPLayout/PSPLayout';

export const JumpNav = ({ activeLink, handleLinkClick }) => {
	return (
		<Container className="quick-links-container">
			<span className="jump-to">Jump To:</span>
			{quickLinks.map((link) => (
				<Button
					key={link.id}
					className={`quick-link ${activeLink === link.id ? 'active' : ''}`}
					onClick={handleLinkClick(link.id)}
					tabIndex={0}
				>
					{link.label}
				</Button>
			))}
		</Container>
	);
};

JumpNav.propTypes = {
	activeLink: PropTypes.string,
	handleLinkClick: PropTypes.func.isRequired,
};
